declare global {
  interface Window {
    MobileApp: {
      closeWebViewAndRefreshData: () => void;
      updateLeftNavigationIcon: (iconName: string) => void;
    };
  }
}

export const closeAndRefreshIcon = () => {
  if (window?.MobileApp?.closeWebViewAndRefreshData) {
    window.MobileApp.closeWebViewAndRefreshData();
  }
};

export const UpdateNavigationIconBack = () => {
  if (typeof window !== 'undefined' && window?.MobileApp?.updateLeftNavigationIcon) {
    window.MobileApp.updateLeftNavigationIcon('back');
  }
  return null;
};

export const UpdateNavigationIconClose = () => {
  if (typeof window !== 'undefined' && window?.MobileApp?.updateLeftNavigationIcon) {
    window.MobileApp.updateLeftNavigationIcon('close');
  }
  return null;
};
